import React, { Component, Fragment } from 'react'
import { Icon } from '@scentregroup/ui'
import PropTypes from 'prop-types'
import classNames from 'classnames'
import analyticsUtils from '../../../helpers/analytics-utils'
import NavigationGroup from './navigation-group'
import style from './index.module.scss'

class Menu extends Component {
  state = {
    open: false,
  }

  componentDidMount() {
    window.addEventListener('click', this.handleBackgroundClick)
  }

  componentDidUpdate(prevProps, prevState) {
    if (this.state.open !== prevState.open) {
      this.updateScrollLock()
    }
  }

  componentWillUnmount() {
    this.updateScrollLock(false)
    window.removeEventListener('click', this.handleBackgroundClick)
  }

  menuRef = elm => {
    this.menuElm = elm
  }

  handleBackgroundClick = e => {
    if (!this.menuElm.contains(e.target)) {
      this.setState({ open: false })
    }
  }

  handleProductsClick = () => {
    analyticsUtils.gaTagTracking({
      event: analyticsUtils.events.PRODUCTS_MENU_CLICK,
      eventCategory: analyticsUtils.categories.DROPDOWN_CLICK,
      eventAction: analyticsUtils.actions.CLICK,
    })

    this.updateOpenState()
  }

  updateOpenState = () => {
    this.setState(state => ({
      open: !state.open,
    }))
  }

  // When the menu is open stop the body from scrolling
  updateScrollLock = (state = this.state.open) => {
    document.body.classList.toggle(style['_no-scroll'], state)
  }

  render() {
    const { navigationMenu } = this.props
    return (
      <div className={style.menu} ref={this.menuRef}>
        <button
          data-test-id="page-title"
          className={classNames(style.title, 'collapsable')}
          onClick={this.handleProductsClick}
        >
          Products
          <Icon
            type={this.state.open ? 'chevron-up' : 'chevron-down'}
            size="small"
            className={classNames(style.navigationCarrot, 'collapsable')}
            role="presentation"
          />
        </button>
        {this.state.open && (
          <Fragment>
            <div className={style.background} />

            <nav className={style.navigation}>
              {navigationMenu.map(group => (
                <NavigationGroup
                  key={`nav-${group.title}`}
                  navigationGroup={group}
                  onItemClick={this.updateOpenState}
                />
              ))}
            </nav>
          </Fragment>
        )}
      </div>
    )
  }
}

Menu.propTypes = {
  navigationMenu: PropTypes.array.isRequired,
}

export default Menu
